import React from 'react';
import './SpaceUpOne.css';
import Header from '../Header/Header';
import SpaceUpOneDisplay from '../../Components/SpaceUpOneDisplay/SpaceUpOneDisplay';

const SpaceUpOne = () => {
    return (
        <div>
            <Header></Header>
            <SpaceUpOneDisplay></SpaceUpOneDisplay>
            
        </div>
    );
};

export default SpaceUpOne;